export interface IFeatureFlag {
  isEnabled: boolean; // flag is enabled
  organizationIds: Array<number>; // if entry exists, is enabled for only the provided organization
  // accounts: Array<string> // if entry exists, is enabled for only the provided accounts (not supported until we can get a good way to manage switching accounts)
}

export type FeatureFlags = Record<string, IFeatureFlag | undefined>;

export type FeatureFlagKey = string;

const prodFlags: FeatureFlags = {
  // 281 = Dyno
  ReportDownload: { isEnabled: true, organizationIds: [281] },
};

const qaFlags: FeatureFlags = {
  // 273 = Dyno
  ReportDownload: { isEnabled: true, organizationIds: [273] },
};

export const flags: FeatureFlags = import.meta.env.PROD ? prodFlags : qaFlags;
